// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Receipt } from '@tectonics/prs/receipts';

export function getFinalReceipt(incomingPayment: IncomingPayment): Receipt {
  if (incomingPayment.status === 'OP')
    throw new Error(`FinalReceipt: it's not available in a payment with status: "${incomingPayment.status}"`);

  return incomingPayment['final_receipt'];
}
